import { useState } from "react";
import {
    Input,
    Button,
    Modal,
    Radio,
    DatePicker,
    Select,
} from 'antd';
import {
    Calendar,
    Search,
    X,
} from 'lucide-react';

import dayjs from 'dayjs';

/* ============================================================
 * Modal tùy chỉnh bộ lọc
 * ============================================================ */
export const ModalCustomFilter = ({ open, onCancel, }: { open: boolean; onCancel: () => void; }) => {
    const [viewBy, setViewBy] = useState("year");

    return (
        <Modal
            open={open}
            onCancel={onCancel}
            footer={
                <div className="flex justify-end gap-3 flex-wrap">
                    <Button
                        onClick={onCancel}
                        className="px-5 py-2.5 dark:text-white font-medium rounded-md text-xs"
                        style={{ background: "transparent" }}
                    >
                        HỦY BỎ
                    </Button>

                    <Button
                        type="primary"
                        className="px-5 py-2.5 text-white font-medium rounded-md text-xs"
                    >
                        CẬP NHẬT
                    </Button>
                </div>
            }
            title={
                <span className="text-[15px] font-medium">
                    Tùy chỉnh
                </span>
            }
        >
            <div className="flex flex-col gap-5 text-sm">
                <div>
                    <label className="text-xs text-gray-500 mb-2 block">
                        Xem theo
                    </label>
                    <Radio.Group
                        value={viewBy}
                        onChange={(e) => setViewBy(e.target.value)}
                        className="flex items-center gap-6"
                    >
                        <Radio value="year">Năm</Radio>
                        <Radio value="quarter">Quý</Radio>
                        <Radio value="month">Tháng</Radio>
                    </Radio.Group>
                </div>

                <div>
                    <label className="text-xs text-gray-500 mb-1 block">
                        Năm
                    </label>
                    {/* <Input
                        defaultValue="2022"
                        suffix={<Calendar size={16} className="text-gray-400" />}
                    /> */}
                    <DatePicker className="w-full" picker="year" defaultValue={dayjs('2022')} />
                </div>

                <div>
                    <label className="text-xs text-gray-500 mb-1 block">
                        Công ty
                    </label>
                    {/* <Input
                        defaultValue="CÔNG TY CỔ PHẦN 1OFFICE"
                        suffix={<X size={14} className="text-gray-400 cursor-pointer" />}
                    /> */}
                    <Select
                        className="w-full"
                        defaultValue='0'
                        options={[
                            { value: '0', label: 'CÔNG TY CỔ PHẦN 1OFFICE' },
                        ]} />
                </div>

                <div>
                    <label className="text-xs text-gray-500 mb-1 block">
                        Từ khóa
                    </label>
                    <Input
                        placeholder="Tìm kiếm theo mã, tên"
                        prefix={<Search size={14} className="text-gray-400" />}
                    />
                </div>
            </div>
        </Modal>
    );
}